import useSchedule from "@/shared/queries/schedules/useSchedule";
import { CmsUsersResponse } from "@/shared/utils/interfaces";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Textfield from "../Input/Textfield";
import { formatPrice } from "@/shared/utils/helpers";

const DepositStartMoney = ({ courier }: { courier: CmsUsersResponse }) => {
  const schedule = useSchedule(courier?.item_id);
  const { t: tG } = useTranslation();
  const defaultValue = parseInt(schedule?.money_at_start_of_day);
  const { register, errors } = useFormContext();

  return (
    <Textfield
      ref={register({
        valueAsNumber: true,
        required: {
          value: false,
          message: tG("fieldRequired"),
        },
      })}
      defaultValue={defaultValue}
      min={0}
      step="0.10"
      type="number"
      error={errors?.money_at_start_of_day?.message}
      label={tG("money_at_start_of_day")}
      name="money_at_start_of_day"
      placeholder={tG("depositAmountPlaceholder", { price: formatPrice(5) })}
    />
  );
};

export default DepositStartMoney;
